export default "__VITE_ASSET__77q4Nc7$__"